import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { IPackageReducer } from "../interfaces/IRedux";
import { IArticle, IPackage } from "../interfaces/IPackage";

import ModalConfirmation from "./ModalConfirmation";
import TableDetailArticlesPackage from "components/tableDetailArticlesPackage";

import { LoaderDots } from "../components/loaders";
import { showModal } from "../utils/domUtils";
import { articles as articleStatus, packages as packageStatus } from "../config/statusConfig";

import { updateArticlePackageStatus, markClientPackageCompleted } from "../actions/packageActions";

interface ComponentProps {
  modal_id: string;
  package?: IPackageReducer;
  currentPackage: IPackage;
  updateArticlePackageStatus: Function;
  markClientPackageCompleted: Function;
}

class ClientPackageDetailModal extends Component<ComponentProps, {}> {
  state = {
    idmodal_confirmation: "modal_confirm_complete_package",
  };

  onMarkCompletePackageClick = () => {
    showModal(this.state.idmodal_confirmation);
  };
  onConfirmCompletePackage = () => {
    this.props.markClientPackageCompleted(
      this.props.currentPackage.id
    )
  };

  canMarkAsCompleted(): boolean {
    if (!this.props.currentPackage) {
      return false;
    }
    const status = [packageStatus.empty, packageStatus.completing]
    if (!status.includes(this.props.currentPackage.status)) {
      return false;
    }
    const articlesReceived = this.props.package.itemArticles.filter(i => i.status === articleStatus.received)
    if (articlesReceived.length === 0) {
      return false;
    }
    return true;
  }

  onArticleClickAction = (article: IArticle, actionType: string) => {
    if (!article || !actionType || article.received) return;

    let newStatus;
    if (actionType === "disactive") {
      newStatus = articleStatus.disactive;
    } else if (actionType === "active") {
      newStatus = articleStatus.waiting;
    } else if (actionType === "delete") {
      newStatus = articleStatus.removed;
    }
    if (!newStatus || newStatus === article.status) return;

    this.props.updateArticlePackageStatus({
      status: newStatus,
      id: article.id,
      id_package: article.id_package,
      remove: actionType === "delete",
    });
  };

  getContent = (currentPackage: IPackage) => {
    if (!currentPackage) return;
    return (
      <>
        {this.getPackageProgress(currentPackage)}
        {this.getArticlesDetail()}
      </>
    );
  };

  getArticlesDetail = () => {
    if (this.props.package.loadingOperation) return <LoaderDots />;
    if (this.props.package.itemArticles.length === 0)
      return <div>No hay articulos agregados</div>;
    return (
      <div className="modal-scroll-inner">
        <TableDetailArticlesPackage
          articles={this.props.package.itemArticles}
          onDropDownClick={this.onArticleClickAction}
          packageStatus={this.props.currentPackage.status}
        />
      </div>
    );
  };

  getPackageProgress = (currentPackage: IPackage) => {
    const { count_articles, count_articles_received } = currentPackage;
    let packagePercent = 0;

    if (count_articles > 0) {
      packagePercent = (count_articles_received / count_articles) * 100;
    }
    return (
      <div>
        <div>
          <p>
            {count_articles_received} / {count_articles} Articulos{" "}
            <span className="float-right">{packagePercent}%</span>
          </p>
          <div
            className="progress mb-4"
            style={{
              height: "4px",
            }}
          >
            <div
              className="progress-bar bg-success"
              role="progressbar"
              style={{
                width: `${packagePercent}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const currentPackage = this.props.currentPackage;
    let actionButton;

    if (this.canMarkAsCompleted()) {
      actionButton = (
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={this.onMarkCompletePackageClick}
        >
          Marcar como completado
        </button>
      )
    } else {
      actionButton = (<div></div>)
    }

    return (
      <>
        <div
          className="modal fade"
          role="dialog"
          aria-hidden="true"
          id={this.props.modal_id}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{currentPackage?.name || "NA"}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.getContent(currentPackage)}
              </div>
              <div className="modal-footer">
                <div className="flex-2-separated">
                  {actionButton}
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-dismiss="modal"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalConfirmation
          modal_id={this.state.idmodal_confirmation}
          message="Los articulos que aun no han llegado dejaran de ser esperados y el paquete iniciara el proceso para su envio al pais"
          question="Realmente desea confirmar este paquete como completado?"
          onAccept={this.onConfirmCompletePackage}
        />
      </>
    );
  }
}

// @ts-ignore
ClientPackageDetailModal.propTypes = {
  modal_id: PropTypes.string.isRequired,
  package: PropTypes.object.isRequired,
  currentPackage: PropTypes.object,
};
// @ts-ignore
ClientPackageDetailModal.defaultProps = {
  modal_id: "modal_package_detail",
};

const mapStateToProps = (state) => ({
  package: state.package,
});

export default connect(mapStateToProps, { updateArticlePackageStatus, markClientPackageCompleted })(
  ClientPackageDetailModal
);
